import { render } from "./UserSocials.vue?vue&type=template&id=1eed8493"
import script from "./UserSocials.vue?vue&type=script&lang=js"
export * from "./UserSocials.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__